import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  root: {
    minHeight: '100%',
    overflow: 'auto',
    backgroundColor: '#F4F4F4',
  },
})
